module.exports = __webpack_public_path__ + "img/portal3.5836b4df.png";